/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-useless-escape */
/**
 * extractFullName: extract fullName to [lastName, middleName, firstName];
 * @param {*} fullName
 * @returns [lastName, middleName, firstName];
 */
export const extractFullName = (fullName = '') => {
  if (!fullName || !fullName?.length) {
    return ['', '', ''];
  }
  const splitFullName = fullName.trim().split(' ');
  const lastName = splitFullName[0];
  const firstName =
    splitFullName?.length < 2 ? '' : splitFullName[splitFullName.length - 1];
  const middleName =
    splitFullName.length > 2
      ? splitFullName
          .slice(1, splitFullName.length - 1)
          .join(' ')
          .trim()
      : '';
  return [lastName, middleName, firstName];
};

/**
 * debounce execution
 * @param {*} callback, wait
 * @returns cb function
 */
export function debounce(callback, wait = 300) {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
}

/**
 * getCookie funtion
 * @param {name} get value in cookie by name
 */
export function getCookie(name) {
  // ; name=<value>
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
    ),
  );
  // a cookie value is encoded
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

/**
 * setCookie
 * @param {*} name string
 * @param {*} value string or any
 * @param {*} options object any option of cookie
 */
export function setCookie(name, value, options = {}) {
  const cookieOpts = {
    path: '/',
    ...options,
  };
  if (cookieOpts.expires instanceof Date) {
    cookieOpts.expires = cookieOpts.expires.toUTCString();
  }
  let updateCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  for (const optKey in cookieOpts) {
    updateCookie += `; ${optKey}`;
    const optValue = cookieOpts[optKey];
    if (optValue !== true) {
      updateCookie += `=${optValue}`;
    }
  }
  document.cookie = updateCookie;
}

/**
 * setCookie
 * @param {*} ir   - interest rate per month
 * @param {*} np   - number of periods (months)
 * @param {*} pv   - present value
 * @param {*} fv   - future value
 * @param {*} type - when the payments are due - 0: end of the period, e.g. end of month (default) - 1: beginning of period
 */
export function PMT(ir, np, pv, fv = 0, type = 0) {
  let pmt;

  if (ir === 0) return -(pv + fv) / np;
  const pvif = (1 + ir) ** np;
  pmt = (-ir * (pv * pvif + fv)) / (pvif - 1);

  if (type === 1) pmt /= 1 + ir;

  return pmt;
}
